import { render, staticRenderFns } from "./order-history-description.vue?vue&type=template&id=72c67762&"
import script from "./order-history-description.vue?vue&type=script&lang=ts&"
export * from "./order-history-description.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports